export default {
  name: 'headers',
  label: {
    title: '平台Header',
    icon: require('@/assets/icon-component-label_Headers.svg'),
    limit: 1
  },
  sort: 1001
}
